﻿import '../royal.validator.setdefaults.es6';

$(function () {
  $('form').validate();
  $('#usrTxt').focus();
});

const app = {};
export default app;